import { render, staticRenderFns } from "./TrackingOrderTabWithoutTab.vue?vue&type=template&id=d6d4da06&"
import script from "./TrackingOrderTabWithoutTab.vue?vue&type=script&lang=js&"
export * from "./TrackingOrderTabWithoutTab.vue?vue&type=script&lang=js&"
import style0 from "./TrackingOrderTabWithoutTab.vue?vue&type=style&index=0&id=d6d4da06&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports